import React from 'react';

import classes from'./YoutubeScript.module.css';

const YoutubeScript = (props) => {

    const steamVideoPattern = /^https?:\/\/(?:[a-zA-Z0-9-]+\.)?akamai\.steamstatic\.com\/.*\.(webm|mp4|ogv)(\?.*)?$/i;

    const getYouTubeVideoId = (url) => {
        let videoId = url;

        // Check if it's a standard YouTube URL
        const standardYouTubePattern = /youtube\.com\/watch\?v=([^&]+)/;
        const shortenedYouTubePattern = /youtu\.be\/([^?]+)/;

        if (standardYouTubePattern.test(url)) {
            videoId = url.match(standardYouTubePattern)[1];
        } else if (shortenedYouTubePattern.test(url)) {
            videoId = url.match(shortenedYouTubePattern)[1];
        }

        return videoId;
    };


    let video = "";
    let source_link = 'https://www.youtube.com/embed/' + getYouTubeVideoId(props.id);
    if (steamVideoPattern.test(props.id)) {
        source_link = props.id;
        video = (
            <iframe
                title={props.id}
                src={source_link}
                frameBorder="0"
                rel="0"
                allow="accelerometer; encrypted-media; gyroscope; mute;"
                allowFullScreen></iframe>
        );
    } else {
        video = (
            <iframe
                title={props.id}
                src={source_link}
                frameBorder="0"
                rel="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope;"
                allowFullScreen></iframe>
        );
    }


    return (
        <div className={"card " + classes.VideoCard}>
            <h5 className="card-header">{props.videoType}</h5>
            <div className={"card-body " + classes.EmbedContainer}>
                {video}
            </div>
        </div>
    );
};

export default YoutubeScript;